import React from 'react';
import { CheckIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
import { price, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function SummaryTable() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-220" data-mp="o71jkm7hsj9a">
      <div className="mx-auto max-w-4xl px-4" data-id="element-221" data-mp="j7yej1riid1b">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-navy sm:text-4xl" data-id="element-222" data-mp="j53tp94l6q7d">
          Everything included
        </h2>
        <p className="mt-3 text-center text-muted" data-id="element-223" data-mp="1bvcbgzv7n8lf">
          {productShortName} · {totalVolumes} volumes + {totalBonuses} bonuses ·{' '}
          <b className="text-navy" data-id="element-224" data-mp="16v6kllwrlq4e">{price}</b>
        </p>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-225" data-mp="12vpecq9ikoy6">
          {summaryRows.map(([feature, detail]) => <li key={feature} className="flex gap-3 rounded-lg border border-line bg-mist p-4" data-id="element-226" data-mp="3ro1l146w1vo2">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-leaf" data-id="element-227" data-mp="3nl56bokgyjpe">
                <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-228" data-mp="3ie7l30ggrkfh" />
              </span>
              <p data-id="element-229" data-mp="3nao9zwvhm2tm">
                <b className="block text-sm text-navy" data-id="element-230" data-mp="3nb7of3lxi92w">{feature}</b>
                <span className="text-sm text-muted" data-id="element-231" data-mp="39b6fr1zf9xcv">{detail}</span>
              </p>
            </li>)}
        </ul>

        <blockquote className="mx-auto mt-10 max-w-2xl rounded-xl border-l-4 border-solar bg-solarSoft px-6 py-5 text-center text-lg font-bold leading-relaxed text-navy" data-id="element-232" data-mp="3dc02hs14p646">
          “The best time to have these materials was at the start of your year. The second-best time is today.”
        </blockquote>
      </div>
    </section>;
}